import { Spot } from "../global-commons/type";

export function convertSpotsToGeoJson(
  spots: Spot[]
): GeoJSON.FeatureCollection {
  const features: GeoJSON.Feature[] = spots.map((spot) => {
    const geometry: GeoJSON.Point = {
      type: "Point",
      coordinates: [
        parseFloat(spot.place.gmap_x),
        parseFloat(spot.place.gmap_y),
      ],
    };

    return {
      id: spot.topics_id.toString(),
      type: "Feature",
      geometry,
      properties: {
        markerImageUrl: spot.markerImage.url,
        subject: spot.subject,
        uniqueId: crypto.randomUUID(), // topics_idはクラスターIDと重複する可能性があるため、代わりにUUIDを使用
        topicsId: spot.topics_id,
      },
    };
  });

  return {
    type: "FeatureCollection",
    features,
  };
}
/** FeatureCollection型のGeoJSONに対して、特定のtopicsIdを持つFeatureのプロパティを設定する関数 */
export function setPropertyToFeature(
  geoJson: GeoJSON.FeatureCollection,
  topicsId: number,
  propertyName: string,
  propertyValue: string
) {
  const feature = geoJson.features.find(
    (f) => f.properties!.topicsId === topicsId
  );
  if (!feature) {
    console.warn(`Feature with topicsId ${topicsId} not found.`);
    return;
  }

  feature.properties = feature.properties || {};
  feature.properties[propertyName] = propertyValue;
}
